import {  useNavigate } from "react-router-dom";
import { GoChevronLeft } from "react-icons/go";

export default function BackNav() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="bg-white flex items-center border-gray-300 py-1 px-2 hover:text-fish w-full"
    >
      <div className="">
        <GoChevronLeft size={20}/>
      </div>
      <div className="mx-1">Back</div>
    </button>
  );
}
